import PropTypes from 'prop-types';
import React from 'react';
import { Button, ButtonGroup, DropdownButton, MenuItem } from 'react-bootstrap';
// import Floater from 'react-floater';
import TourManagerModal from './TourManagerModalContainer';
import AddBookingModal from './AddBookingModalContainer';
import ManageBidFilterDropDown from './ManageBidFilterDropDown';
import CompareBidsModal from "./CompareBidsContainer";

class ManageBidsMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      showAddBookingModal: false,
      showCompareBids: false
    };
    this.close = this.close.bind(this);
    this.closeAddBookingModal = this.closeAddBookingModal.bind(this);
    this.open = this.open.bind(this);
    this.showAddBookingModalPopup = this.showAddBookingModalPopup.bind(this);
    this.downloadTourPdf = this.downloadTourPdf.bind(this);
    this.downloadTourXls = this.downloadTourXls.bind(this);
    this.downloadHotelXls = this.downloadHotelXls.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleTourManagerView = this.toggleTourManagerView.bind(this);
  }

  close() {
    this.setState({ showModal: false });
  }
  closeAddBookingModal() {
    this.setState({ showAddBookingModal: false });
  }
  open() {
    this.setState({ showModal: true });
  }
  showAddBookingModalPopup() {
    this.setState({ showAddBookingModal: true });
  }


  closeCompareBids = () => {
    this.setState({ showCompareBids: false });
  }
  openCompareBids = () => {
    this.setState({ showCompareBids: true });
  }


  downloadTourPdf() {
    const payload = { format: 'application/pdf', report: 'tour' };
    console.log('payload =' + payload);
    this.props.downloadTourPdf(this.props.id, payload);
  }
  downloadTourXls() {
    const payload = { format: 'application/vnd.ms-excel', report: 'tour' };
    this.props.downloadTourPdf(this.props.id, payload);
  }
  downloadHotelXls() {
    const payload = { format: 'application/vnd.ms-excel', report: 'hotel' };
    console.log('downloadHotelXls called');
    this.props.downloadTourPdf(this.props.id, payload);
  }

  toggleTourManagerView() {
    this.props.setTourManagerSimMode(this.props.isTourManager);
  }
  handleSubmit(values) {
    this.props.sendToTourManager(this.props.id, values);
    this.close();
  }
  render() {
    const readOnlyOrTourManager = this.props.readOnly || this.props.isTourManager;
    const downloadTitle = (
      <span>
        <i className="fa fa-download" aria-hidden="true" /> Download
      </span>
    );
    return (
      <div className="row">
        {!readOnlyOrTourManager && (
          <ButtonGroup>
            <Button
              id={this.props.id}
              bsStyle="info"
              onClick={this.open}
              title="Share with Client"
            >
              <i className="fa fa-share-alt" aria-hidden="true" /> Share
            </Button>
            <Button
              id={this.props.id}
              bsStyle="info"
              onClick={this.toggleTourManagerView}
              title="See what Client can do in Catch"
            >
              <i className="fa fa-eye" aria-hidden="true" /> Preview Client View
            </Button>&nbsp;&nbsp;&nbsp;
          </ButtonGroup>
        )}
        <DropdownButton title={downloadTitle} id="bg-nested-dropdown" bsStyle="info">
          {/*
          <MenuItem
            id={this.props.id}
            bsStyle="info"
            onClick={this.downloadTourPdf}
            title="Download Travel Itinerary and Hotels as PDF"
          >
            <i className="fa fa-file-pdf-o" aria-hidden="true" /> Itinerary
          </MenuItem> */}
          <MenuItem
            id={this.props.id}
            bsStyle="info"
            onClick={this.downloadTourXls}
            title="Download Travel Itinerary and Hotels as Excel"
          >
            <i className="fa fa-file-excel-o" aria-hidden="true" /> Itinerary
          </MenuItem>
          <MenuItem divider />
          <MenuItem
            id={this.props.id}
            bsStyle="info"
            onClick={this.downloadHotelXls}
            title="Download Hotel Options as Excel"
          >
            <i className="fa fa-file-excel-o" aria-hidden="true" /> Hotel Options
          </MenuItem>
        </DropdownButton>
        <a id="pdf-link" />
        <ButtonGroup style={{ marginLeft: "10px" }}>

          {!readOnlyOrTourManager && (
            <Button
              id={this.props.id}
              bsStyle="info"
              onClick={this.showAddBookingModalPopup}
              title="Add a new bid"
            >
              <i className="fa fa-user" aria-hidden="true" /> Add Bid
            </Button>
          )}
          <Button
            bsStyle="info"
            title="Compare Bids"
            onClick={this.openCompareBids}
          >
            <i className="fa fa-usd" aria-hidden="true" /> Compare Bids
          </Button>
          {!readOnlyOrTourManager && (
            <Button
              id={this.props.id}
              bsStyle="info"
              onClick={this.props.showUpdate}
              title="Send update to selected hotels"
            >
              <i className="fa fa-commenting" aria-hidden="true" /> Send Update
            </Button>
          )}
          <ManageBidFilterDropDown
            groups={this.props.groups}
            filter={this.props.filter}
            bidFilterSet={this.props.bidFilterSet}
          />
        </ButtonGroup><br/><br/>
        <ButtonGroup>
          &nbsp;&nbsp;&nbsp;<Button style={{'float':'right'}} title={this.props.showView?("List View"):("Location View")} onClick={this.props.changeShowView}>{this.props.showView?(<i className="fa fa-th-large"></i>):(<i className="fa fa-bars"></i>)}</Button><br/>
        </ButtonGroup>
        {this.state.showModal && (
          <TourManagerModal
            show={this.state.showModal}
            onClose={this.close}
            readOnly={this.props.readOnly}
          />
        )}
        {this.state.showAddBookingModal && (
          <AddBookingModal
            show={this.state.showAddBookingModal}
            onClose={this.closeAddBookingModal}
            readOnly={this.props.readOnly}
            groups={this.props.groups}
            tour={this.props.tour}
            saveAddBookingData={this.props.saveAddBookingData}
            user={this.props.user}
          />
        )}
        {this.state.showCompareBids && (
          <CompareBidsModal
            show={this.state.showCompareBids}
            onClose={this.closeCompareBids}
          />
        )}
      </div>
    );
  }
}

ManageBidsMenu.propTypes = {
  id: PropTypes.number.isRequired,
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  isTourManager: PropTypes.bool,
  sendToTourManager: PropTypes.func.isRequired,
  downloadTourPdf: PropTypes.func.isRequired,
  setTourManagerSimMode: PropTypes.func.isRequired,
  messageSet: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired,
  filter: PropTypes.object,
  bidFilterSet: PropTypes.func.isRequired,
  showUpdate: PropTypes.func.isRequired,
  changeShowView: PropTypes.func.isRequired,
};

ManageBidsMenu.defaultProps = {
  isTourManager: true,
};
export default ManageBidsMenu;



// WEBPACK FOOTER //
// src/routes/tours/components/ManageBidsMenu.js